interface MNavigationState {
  workOrderMode: boolean;
}

const state: MNavigationState = {
  workOrderMode: false,
};

const mutations = {
  SET_WORK_ORDER_MODE(state: MNavigationState, payload: boolean) {
    state.workOrderMode = payload;
  },
};

const actions = {
  setWorkOrderMode(context: any, woMode: boolean) {
    context.commit("SET_WORK_ORDER_MODE", woMode);
  },
};

const getters = {
  workOrderMode: (state: MNavigationState) => state.workOrderMode,
};

const mNavigationModule = {
  state,
  mutations,
  actions,
  getters,
};

export default mNavigationModule;
